// Interface

import util from '@/utils/classToObject'
import { IAuthState } from './state'
import { SecurityRoles } from '@/enum/SecurityItems'

export class AuthGetter {
  public isAuthenticated(state: IAuthState) {
    return state.token && state.token.length > 0
  }
  public isWsReady(state: IAuthState) {
    return state.token && state.token.length > 0 && state.userProfile && state.userProfile.id > 0
  }
  public wsUrl(state: IAuthState) {
    return state.wsUrl
  }
  public authStatus(state: IAuthState) {
    return state.authStatus
  }
  public changePwdStatus(state: IAuthState) {
    return state.changePwdStatus
  }
  public token(state: IAuthState) {
    return state.token
  }
  public userProfile(state: IAuthState) {
    return state.userProfile
  }
  public isSysAdmin(state: IAuthState) {
    return (
      state.userProfile && state.userProfile.roles && state.userProfile.roles.some(it => it == SecurityRoles.sysadmin)
    )
  }
  public isAdmin(state: IAuthState) {
    return state.userProfile && state.userProfile.roles && state.userProfile.roles.some(it => it == SecurityRoles.admin)
  }
  public isManager(state: IAuthState) {
    return (
      state.userProfile && state.userProfile.roles && state.userProfile.roles.some(it => it == SecurityRoles.manager)
    )
  }
  public isOperator(state: IAuthState) {
    return (
      state.userProfile && state.userProfile.roles && state.userProfile.roles.some(it => it == SecurityRoles.operator)
    )
  }
  public userSecurity(state: IAuthState) {
    return state.userSecurity
  }
  public renewTokenId(state: IAuthState) {
    return state.renewTokenId
  }
}

export default util.classToObject(AuthGetter)
